/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:23:35
 * @LastEditTime: 2024-07-24 08:48:27
 * @Description:
 */
import './bought.scss'
import React, { useState, useEffect } from 'react'
import bgPng from '../../static/bought/bg.png'
import { Toast, Image, Button, Tabs, InfiniteScroll } from 'antd-mobile'
import { getPayReportListApi, emailReportPackageDownloadApi, sendEmailByReportApi } from '../../api/yearEndReportApi'

import EMailModal from '../../components/MEmail/index'
import { useNavigate } from 'react-router-dom'
import wxConfig from '../../utils/wxConfig'
import MHead from '../../components/MHead/index'

let ReportList = ({ reports }) => {
  // document.title = '解锁/购买的报告'
  document.title = '瑞莱博2023年物流地产年度报告'
  useEffect(() => {
    // wxConfig()
  }, [])

  let navigate = useNavigate()
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
  let goDetail = (topicId) => {
    navigate(`/rlb/YearEndReport/detail/${topicId}`)
  }

  let [visiblePackAge, setVisiblePackAge] = useState(false)
  // 全部打包下载
  let downLoadPackage = async (email) => {
    let res = await emailReportPackageDownloadApi({
      openId: userInfo.openId,
      email,
    })
    Toast.show(res.msg)
    setVisiblePackAge(false)
  }

  let [visible, setVisible] = useState(false)
  //  打包
  let send = async (email, selectRegionList = selectRegionId) => {
    let res = await sendEmailByReportApi({
      openId: userInfo.openId,
      email,
      topicId: selectRegionList,
      type: 0
    })
    Toast.show(res.msg)
    setVisible(false)
  }


  let [selectRegionId, setSelectRegionId] = useState('')
  let downLoadHandle = (regionId) => {
    // if (userInfo.email) {
    //   send(userInfo.email, regionId)
    // } else {
    setVisible(true)
    setSelectRegionId(regionId)
    // }
  }

  return (
    <div className="ReportList">
      <div className="listWrap">
        {reports.map((item) => {
          return (
            <div className="listItem" key={item.regionId}>
              <div className="listItemTitle">
                <h6>
                  {item.regionName}
                  {
                    !(item.topics && item.topics.length > 0) && <em
                      onClick={() => {
                        goDetail(item.regionId)
                      }}
                    >
                      查看
                    </em>
                  }

                </h6>

                <Button
                  color="primary"
                  fill="outline"
                  size="mini"
                  onClick={() => {
                    downLoadHandle(item.regionId)
                  }}
                >
                  下载报告
                </Button>
              </div>
              {
                item.topics.map((it) => {
                  return (
                    <div className="reportItem" key={it.topicId}>
                      <span>{it.topicName}</span>
                      <em
                        onClick={() => {
                          goDetail(it.topicId)
                        }}
                      >
                        查看
                      </em>
                    </div>
                  )
                })
              }
            </div>
          )
        })}
      </div>
      {
        reports && reports.length > 0 && <div className="btnWrap">
          <Button
            block
            className="btn"
            color="primary"
            size="large"
            onClick={() => {
              setVisiblePackAge(true)
            }}
          >
            邮件打包下载
          </Button>
        </div>
      }

      <EMailModal okText='确认发送' visible={visiblePackAge} setVisible={setVisiblePackAge} send={downLoadPackage} />
      <EMailModal okText='确认发送' visible={visible} setVisible={setVisible} send={send} />
    </div >
  )
}

let PaymentList = ({ pays }) => {
  return (
    <>
      <div className="PaymentList">
        {pays.map((item) => {
          return (
            <div className="item" key={item.id}>
              <div>
                <p>{item.regionName}</p>
                <p>
                  {item.topics
                    .map((it) => {
                      return it.topicName
                    })
                    .join('/')}
                </p>
              </div>

              {/* {item.type === 1 && <p>锦囊 -{item.amount}</p>} */}
              {item.type === 1 && <p>{item.amount}</p>}
              {item.type === 2 && <p>-{item.amount}元</p>}
            </div>
          )
        })}
      </div>
      {/* <InfiniteScroll loadMore={loadMore} hasMore={hasMore} /> */}
    </>
  )
}

let Bought = () => {
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
  useEffect(() => {
    init()
  }, [])

  let init = async () => {
    let res = await getPayReportListApi({
      openId: userInfo.openId,
    })
    if (res.status === 200) {
      setReports(res.data.reports)
      setPays(res.data.pays)
    } else {
      Toast.show(res.msg)
    }
  }
  let [reports, setReports] = useState([])
  let [pays, setPays] = useState([])

  return (
    <div className="bought">
      <MHead />
      <Image src={bgPng} fit="cover" width="100%" />
      <Tabs className="TabsTab">
        <Tabs.Tab title="已解锁报告列表" key="1">
          <ReportList reports={reports} />
        </Tabs.Tab>
        <Tabs.Tab title="解锁/付费记录" key="2">
          <PaymentList pays={pays} />
        </Tabs.Tab>
      </Tabs>
    </div>
  )
}

export default Bought
